import {
  UPDATE_CUSINES,
  UPDATE_RESTAURANT_LIST,
  UPDATE_RESTAURANT_SEARCH_KEY,
  UPDATE_RESTAURANT_INFO,

} from "../actionTypes/restaurantTypes";

const initalState = {
  searchKey: "",
  list: {},
  cuisines: [],
  info: {},
};

export function restaurantReducer(state = initalState, action) {
  switch (action.type) {
    case UPDATE_RESTAURANT_SEARCH_KEY: {
      return {

        ...state,
        searchKey: action.payload,

      };
    }
    case UPDATE_RESTAURANT_LIST: {
      return {
        ...state,
        list: action.payload,
      };
    }
    case UPDATE_CUSINES: {
      return {
        ...state,
        cuisines: action.payload,
      };
    }
    case UPDATE_RESTAURANT_INFO: {
      return {
        ...state,
        info: action.payload,
      };
    }


    default:
      return state;
  }
}

